// Validation utility functions

/**
 * Validate email format
 * @param {string} email
 * @returns {boolean}
 */
export function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

/**
 * Validate international phone number format
 * Supports various international formats including:
 * - +1234567890
 * - +1 (234) 567-8900
 * - +44 20 7946 0958
 * - +966 50 123 4567
 * - 001234567890
 * - Local formats: (234) 567-8900, 234-567-8900, etc.
 * @param {string} phone
 * @returns {boolean}
 */
export function isValidPhone(phone) {
    if (!phone || typeof phone !== 'string') return false;
    
    // Remove all spaces, hyphens, parentheses, and dots
    const cleanPhone = phone.replace(/[\s\-\(\)\.]/g, '');
    
    // Check for international format with + or 00 prefix
    const internationalRegex = /^(\+|00)[1-9]\d{7,14}$/;
    
    // Check for local format (7-15 digits)
    const localRegex = /^[0-9]{7,15}$/;
    
    return internationalRegex.test(cleanPhone) || localRegex.test(cleanPhone);
}

/**
 * Format phone number to preserve leading zeros and special characters
 * @param {string} phone
 * @returns {string}
 */
export function formatPhoneForStorage(phone) {
    if (!phone || typeof phone !== 'string') return '';
    
    // Keep the phone number as string to preserve leading zeros and formatting
    return phone.trim();
}
